import '../scss/main.scss';

//TODO Voir si on met dist ou src
import 'bootstrap/js/src/dropdown';
import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/offcanvas';

import './components/recherche-par-code-postal';
import './components/carte-normandie-redirections';
import './components/carte-antennes';
import './components/sliders-mobile';
import './components/autocomplete-multiple';
import './components/masques-champs';
import './components/affichage-champs-conditionnel';
import './components/soumission-formulaire';
import './components/switcher-champ-password';
import './components/redimensionner-iframe-instant-t';
import './components/anchor-instant-t';

(function (global, factory) {
        typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
            typeof define === 'function' && define.amd ? define(factory) :
                (factory());
    }(this, (function () {
        'use strict';

        window.addEventListener('load', function () {
            document.querySelector('html').classList.remove('no-js');

        }, false);
    }))
);
